// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved

import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import {
  Warning,
  ButtonRequestRunInitiate,
  NavLink,
  SpanWithData
} from '../'

import { REQUESTTYPE_IDENTITYBANKACCOUNT_CREATE } from '../../constants'

import { decodeBase64 } from '../../utils'


class BankAccountRequestShowOrCreate extends Component {
  static propTypes = {
    identityId: PropTypes.string.isRequired,
    allowBankAccountCreation: PropTypes.bool,
    showLastCreationRequest: PropTypes.bool,
    className: PropTypes.string
  }

  static defaultProps = {
    allowBankAccountCreation: false,
    showLastCreationRequest: true,
    className: ''
  }


  state = {
    bankAccountInitiateInProgress: false
  }

  render() {
    const { identityId, allowBankAccountCreation, showLastCreationRequest } = this.props

    return (
      <div>
        <Warning iconSize='x-small' inline={true}>
          Client has no verified bank account.
          {showLastCreationRequest
            ? <Query
                query={gql`
                  query($identityId: UUID!, $requestTypeId: UUID!) {
                    requestruns(identity_Id: $identityId, requesttype_Id: $requestTypeId, orderBy: "created_at", last: 1) {
                      edges {
                        node {
                          id
                          status
                          summary
                          identity {
                            id
                          }
                        }
                      }
                    }
                  }
                `}
                variables={{
                  identityId: decodeBase64(identityId),
                  requestTypeId: decodeBase64(REQUESTTYPE_IDENTITYBANKACCOUNT_CREATE)
                }}>

                {({ loading, error, data }) => {
                  if (loading || error) {
                    return null
                  }

                  const bankAccountCreateRequest = data.requestruns.edges.length > 0
                    ? data.requestruns.edges[0].node
                    : null

                  const requestIsOpen = bankAccountCreateRequest &&
                    ['PROCESSED', 'CLOSED_CANCELLED', 'CLOSED_DUPLICATE', 'CLOSED_EXPIRED'].indexOf(bankAccountCreateRequest.status) === -1

                  if (bankAccountCreateRequest && requestIsOpen) {
                    return (
                      <div className='slds-m-top_x-small'>
                        Most recent open bank account creation request:
                        <NavLink
                          to={bankAccountCreateRequest.identity
                            ? `/os/identity/${bankAccountCreateRequest.identity.id}/requests/${bankAccountCreateRequest.id}`
                            : `/os/operations/general/requests/${bankAccountCreateRequest.id}`
                          }
                          className='slds-p-left_small slds-p-right_xx-small'>

                          {bankAccountCreateRequest.summary}
                        </NavLink>
                        (<SpanWithData forField="RequestRunStatus" searchKey={bankAccountCreateRequest.status} />)
                      </div>
                    )
                  }

                  if (allowBankAccountCreation) {
                    return (
                      <ButtonRequestRunInitiate
                        requestTypeId={REQUESTTYPE_IDENTITYBANKACCOUNT_CREATE}
                        identityId={identityId}
                        disabled={this.state.bankAccountInitiateInProgress}
                        onInitiateTriggered={() => this.setState({ bankAccountInitiateInProgress: true })}
                        onInitiateDone={requestRunId => (
                          this.setState(
                            { bankAccountInitiateInProgress: false },
                            this.props.history.push(`/os/identity/${identityId}/requests/${requestRunId}`)
                          )
                        )}
                        buttonType='reset'
                        className='slds-p-left_small'>

                        {this.state.bankAccountInitiateInProgress
                          ? 'Initiating...'
                          : 'Add and verify new account'
                        }
                      </ButtonRequestRunInitiate>
                    )
                  }

                  return null
                }}
              </Query>
            : allowBankAccountCreation &&
              <ButtonRequestRunInitiate
                requestTypeId={REQUESTTYPE_IDENTITYBANKACCOUNT_CREATE}
                identityId={identityId}
                disabled={this.state.bankAccountInitiateInProgress}
                onInitiateTriggered={() => this.setState({ bankAccountInitiateInProgress: true })}
                onInitiateDone={requestRunId => (
                  this.setState(
                    { bankAccountInitiateInProgress: false },
                    this.props.history.push(`/os/identity/${identityId}/requests/${requestRunId}`)
                  )
                )}
                buttonType='reset'
                className='slds-p-left_small'>

                {this.state.bankAccountInitiateInProgress
                  ? 'Initiating...'
                  : 'Add and verify new account'
                }
              </ButtonRequestRunInitiate>
          }
        </Warning>
      </div>
    )
  }
}

export default withRouter(BankAccountRequestShowOrCreate)



// WEBPACK FOOTER //
// ./src/components/select-identity-bankaccount/BankAccountRequestShowOrCreate.js